module.exports = __webpack_public_path__ + "static/media/rgOk.7786c0fb.jpg";